import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { redeemCode } from "../../auth";

const AuthLandingPage = (props) => {
  const authorizationCode = new URLSearchParams(window.location.search).get('authorization_code');
  const navigate = useNavigate();

  useEffect(() => {
    const auth = async () => {
      try {
        if (authorizationCode) {
          const token = await redeemCode(authorizationCode);
          props.setValidAuth(true);
        } else {
          console.error('Authorization code is missing');
          props.setValidAuth(false);
          navigate('/');
        }
      } catch (error) {
        console.error('Validation failed', error);
        props.setValidAuth(false);
        navigate('/');
      }
    };
    auth();
  }, []);

  return (
    <div>
      <h1>One moment, authenticating...</h1>
    </div>
  );
};

export default AuthLandingPage;

